import React, { forwardRef } from 'react';
import { ArrowRight, Rocket, FolderKanban } from 'lucide-react';
import portraitImage from '../../assets/espaces-culturel/moi-sans-fond.png';

const PROOF = [
  { value: '30+', label: 'Projets livrés' },
  { value: '6+', label: "Ans d'expérience" },
  { value: '24h', label: 'Délai de réponse' },
];

const HeroPortrait = forwardRef(function HeroPortrait(_props, ref) {
  return (
    <figure ref={ref} className="hero-zone hero-zone--portrait rihen-hero-panel rihen-hero-panel--portrait">
      <div className="hero-portrait-col" data-depth="0.1">
        <div className="hero-portrait__orbit">
          <div className="hero-portrait__visual">
            <div className="hero-portrait__emit-zone">
              <svg className="hero-portrait__connectors" viewBox="0 0 100 120" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
                <defs>
                  <linearGradient id="haloGrad" x1="0%" y1="100%" x2="0%" y2="0%">
                    <stop offset="0%" stopColor="#B89248" stopOpacity="0.7" />
                    <stop offset="55%" stopColor="#F3980F" stopOpacity="0.45" />
                    <stop offset="100%" stopColor="#F3980F" stopOpacity="0" />
                  </linearGradient>
                </defs>
                <ellipse className="hero-portrait__halo-svg" cx="50" cy="52" rx="34" ry="34" fill="url(#haloGrad)" opacity="0.35" />
                <path className="hero-portrait__halo-arc hero-portrait__halo-arc--1" d="M 18 58 A 32 32 0 0 1 82 58" />
                <path className="hero-portrait__halo-arc hero-portrait__halo-arc--2" d="M 14 58 A 36 36 0 0 1 86 58" />
                <line className="hero-portrait__ray hero-portrait__ray--1" x1="28" y1="56" x2="4" y2="12" />
                <line className="hero-portrait__ray hero-portrait__ray--2" x1="72" y1="56" x2="88" y2="14" />
                <circle className="hero-portrait__anchor" cx="28" cy="56" r="1.4" />
                <circle className="hero-portrait__anchor hero-portrait__anchor--2" cx="72" cy="56" r="1.4" />
              </svg>
            </div>

            <div className="hero-portrait__halo" aria-hidden="true">
              <span className="hero-portrait__halo-ring hero-portrait__halo-ring--1" />
              <span className="hero-portrait__halo-ring hero-portrait__halo-ring--2" />
              <span className="hero-portrait__halo-ring hero-portrait__halo-ring--3" />
            </div>

            <div className="hero-portrait__actions">
              <a
                href="#contact"
                className="hero-portrait__emit hero-portrait__emit--primary hero-manifest__cta hero-manifest__cta--primary"
                style={{ '--emit-i': 0 }}
              >
                <Rocket size={18} />
                Lancer mon projet
                <ArrowRight size={18} />
              </a>
              <a
                href="#projets"
                className="hero-portrait__emit hero-portrait__emit--ghost hero-manifest__cta hero-manifest__cta--ghost"
                style={{ '--emit-i': 1 }}
              >
                <FolderKanban size={18} />
                Mes réalisations
                <ArrowRight size={18} />
              </a>
            </div>

            <div className="hero-portrait__frame">
              <img
                src={portraitImage}
                alt="TALLA FOSSI Florent Martial — Développeur fullstack"
                className="hero-portrait__img"
                loading="eager"
                decoding="async"
              />
              <div className="hero-portrait__glow" aria-hidden="true" />
            </div>

            <div className="hero-portrait__proof">
              <dl className="hero-metrics-orbit" aria-label="Indicateurs clés">
                {PROOF.map((item, index) => (
                  <div
                    key={item.label}
                    className={`hero-metrics-orbit__item hero-metrics-orbit__item--${index + 1}${
                      index === 1 ? ' hero-metrics-orbit__item--featured' : ''
                    }`}
                    style={{ '--proof-i': index }}
                  >
                    <span className="hero-metrics-orbit__index">{String(index + 1).padStart(2, '0')}</span>
                    <dt className="hero-metrics-orbit__value">{item.value}</dt>
                    <dd className="hero-metrics-orbit__label">{item.label}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </figure>
  );
});

export default HeroPortrait;
